@if (showLicenseError) {
  <p class="m-t-20 text-color-warning-red">You can only select users who have a paid license</p>
}
<div class="flex gap-8 m-b-20 m-t-20 wrap">
  @for (host of alternateHosts; track trackById($index, host)) {
    <app-chip (accessoryRightClick)="removeAlternateHost(host.user?.userId)" [text]="getUserName(host.user)">
      @if (host.user) {
        <div accessory-left>
          <profile-picture [size]="28" [user]="host.user" [borderWidth]="'0'"></profile-picture>
        </div>
      }
      <div accessory-right>
        <svg
          class="m-l-4 m-r-4"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="24" height="24" rx="12" fill="#F2F2F2" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.19922 16.0706L7.92779 16.8002L11.9992 12.7292L16.0707 16.8002L16.7992 16.0706L12.7283 12.0002L16.7992 7.92979L16.0707 7.2002L11.9992 11.2712L7.92779 7.2002L7.19922 7.92979L11.2701 12.0002L7.19922 16.0706Z"
            fill="#333333"
          />
        </svg>
      </div>
    </app-chip>
  }
</div>

<div class="selector-container w-full flex flex-column overflow-hidden">
  <div class="search-field w-full">
    <mat-icon>search</mat-icon>
    <input class="selector-search w-full bg-color-grey-400 p-14" placeholder="Search" [formControl]="search" />
  </div>
  <div class="body-wrapper">
    @if (isLoading) {
      <div class="selector-loading-indicator">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
    <div
      class="selector-body"
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="100"
      (scrolled)="fetchMore()"
      [scrollWindow]="false"
    >
      @for (hostCandidate of alternateHostCandidates; track hostCandidate) {
        <div matRipple>
          @if (hostCandidate.user) {
            <div
              class="flex selector-row items-center p-t-12 p-b-12 p-l-34 p-r-34 pointer"
              (click)="selectHost(hostCandidate)"
            >
              <profile-picture [size]="45" [user]="hostCandidate.user" [borderWidth]="'0'"></profile-picture>
              <span class="m-l-34">{{ getUserName(hostCandidate.user) }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
